class MainCart extends HHBaseElement {
  updating = false

  constructor() {
    super()
    this.cart = window.__CART__
    this._handleStickyCTA = this._handleStickyCTA.bind(this)
    this.refresh = this.refresh.bind(this)
    this.$items = this.querySelector('#cart-items .cart-items__items')
    this.$stickyCTA = this.querySelector('.js-main-cart-sticky-cta')
    this.$stickDetect = this.querySelector('.js-main-cart-sticky-detect')
    this.$gwp = this.querySelector('price-progress')
    this.$cartItemsContainer = this.querySelector('.main-cart__items-container')
    this.$checkoutBtns = Array.from(
      this.querySelectorAll('.js-checkout-button')
    )
    this.$cartItemCountInHeader = document.querySelector(
      '[data-header-cart-count]'
    )
    this.$cartFreeSamples = this.querySelector('.js-main-cart__free')
    this.thresholdEnabled = (this.dataset.thresholdEnabled === 'true')
    this.thresholdType = String(this.dataset.thresholdType)
    this.thresholdLimit = Number(this.dataset.thresholdLimit)
  }

  connectedCallback() {
    // this._viewportWatcher()
    this._attachListeners()
    // this._calculateHeaderHeight()
    this.manageFreeSamples(); // Check on page load if samples should be removed from the cart
  }

  disconnectedCallback() {
    this._removeListeners()
  }

  _handleStickyCTA(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.$stickyCTA.classList.remove('stuck')
      } else {
        this.$stickyCTA.classList.add('stuck')
      }
    })
  }

  _attachListeners() {
    this.stickyObserver = new IntersectionObserver(this._handleStickyCTA)

    if (this.$stickDetect) {
      this.stickyObserver.observe(this.$stickDetect)
    }
    document.addEventListener('main-cart::refresh', this.refresh)
    document.addEventListener('cart::add', this.refresh)
  }

  _removeListeners() {
    this.stickyObserver.disconnect()
    document.removeEventListener('main-cart::refresh', this.refresh)
    document.removeEventListener('cart::add', this.refresh)
  }

  async emptyCart() {
    try {
      this.updating = true

      const response = await fetch(`${window.Shopify.routes.root}cart/clear.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })

      if (!response.ok) {
        throw new Error('Failed to update')
      }

      const cart = await response.json()
      this.updateCart(cart)
    } catch (error) {
      console.log(error)
      throw error
    } finally {
      this.updating = false
    }
  }

  async updateQuantity(updates) {
    try {
      this.updating = true

      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        body: JSON.stringify({
          updates,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      })

      if (!response.ok) {
        throw new Error('Failed to update')
      }

      const cart = await response.json()
      this.updateCart(cart)
    } catch (error) {
      console.log(error)
      throw error
    } finally {
      this.updating = false
    }
  }

  async refresh() {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })

      if (!response.ok) {
        throw new Error('Failed to update')
      }

      const cart = await response.json()
      this.updateCart(cart)
    } catch (error) {
      console.log(error)
      throw error
    }
  }

  _applyAttrUpdates() {
    const cartDataAttributes = this.querySelectorAll('[data-cart-attribute]')

    for (const cartDataAttribute of cartDataAttributes) {
      const fetcher = cartDataAttribute.getAttribute('data-cart-attribute')

      if (this.cart.hasOwnProperty(fetcher)) {
        if (cartDataAttribute.hasAttribute('data-format-currency')) {
          cartDataAttribute.innerHTML = Shopify.formatMoney(
            this.cart[fetcher],
            window.money_format
          )
        } else {
          cartDataAttribute.innerHTML = this.cart[fetcher]
        }
      }
    }
  }

  async _fetchRawCartItems() {
    const response = await fetch(`${window.Shopify.routes.root}cart`)
    const container = document.createElement('div')
    container.innerHTML = await response.text()
    const lineItems = container.querySelector('.cart-items__items')
   return lineItems
  }

  async _applyCartItems(previousCart) {
    const cartItems = this.cart.items || []

    if (cartItems.length === 0) {
      this.$cartItemsContainer.classList.add('is-empty')
    } else {
      this.$cartItemsContainer.classList.remove('is-empty')
    }

    // const cartItemsData = await this._fetchRawCartItems()
    // if ( cartItemsData ){
    //   this.$items.innerHTML = cartItemsData.innerHTML

    //   if (typeof window?.appstleInit === 'function') {
    //     window.appstleInit()
    //   }
    // }
  }

  setBusy(status) {
    this.$checkoutBtns.forEach((btn) => {
      if (status) {
        btn.classList.add('disabled')
      } else {
        btn.classList.remove('disabled')
      }
    })
  }

  updateItemCountInHeader() {
    this.$cartItemCountInHeader.innerHTML = this.cart.item_count
    this.$cartItemCountInHeader.classList[
      this.cart.item_count ? 'remove' : 'add'
    ]('hidden')
  }

  _isEmpty(obj) {
    for (const prop in obj) {
      if (Object.hasOwn(obj, prop)) {
        return false
      }
    }

    return true
  }

  async manageFreeSamples() {
    const freeSamplesParams = {}
    const nonFreeItemsCount = this.cart.items.reduce((count, item) => {
      if (!Object.keys(item.properties).includes('_free-sample')) {
        if (!item.gift_card) count += 1
      } else freeSamplesParams[item.key] = 0
      return count
    }, 0)

    if ( this._runThresholdCheck(this.cart) ) {
      if (nonFreeItemsCount === 0 ) {
        if (this.$cartFreeSamples && !this.$cartFreeSamples.classList.contains('hidden')) {
          this.$cartFreeSamples.classList.add('hidden')
        }
        if (!this._isEmpty(freeSamplesParams)) {
          await this.updateQuantity(freeSamplesParams)
        }
        if(this.$cartFreeSamples)
          this.$cartFreeSamples.removedAllFromCart()
      } else {
        if(this.$cartFreeSamples) {
          this.$cartFreeSamples.classList.remove('hidden')
        }
      }
    } else {
      if (nonFreeItemsCount == 0 && this.cart.items.length > 0) this.emptyCart()
      if (this.$cartFreeSamples && !this.$cartFreeSamples.classList.contains('hidden')) {
        this.$cartFreeSamples.classList.add('hidden')
      }
    }
  }

  _getIneligibleLoyaltyLines(cart) {
    try {
      const loyaltyLineKeys = [];
      let hasPaidItemInCart = false;

      cart.items.forEach((cartItem) => {
        if (cartItem.properties['__lion_context']) {
          loyaltyLineKeys.push(cartItem.key);
        } else if (cartItem.final_line_price > 0) {
          hasPaidItemInCart = true;
        }
      })

      return hasPaidItemInCart ? [] : loyaltyLineKeys;
    } catch (error) {
      console.log(error);
      return [];
    }
  }

  async updateCart(cart) {
    const ineligibleLoyaltyLines = this._getIneligibleLoyaltyLines(cart);
    if (ineligibleLoyaltyLines.length) {
      // Remove no longer eligible loyalty redemptions from the cart
      const updates = ineligibleLoyaltyLines.reduce((acc, val) => ({ ...acc, [val]: 0}), {});
      await this.updateQuantity(updates);
    } else {
      try {
        this.setBusy(true)
        this.triggerGlobalEvent('main-cart::refreshed', cart)
        const previousCart = { ...this.cart }
        this.cart = { ...cart }

        this._applyAttrUpdates()
        await this._applyCartItems(previousCart)
        if (this.$gwp) {
          this.$gwp.value = this.cart.items_subtotal_price
        }

        this.updateItemCountInHeader()
        await this.manageFreeSamples()
      } catch (error) {
        console.error(error)
      } finally {
        this.setBusy(false)
      }
    }
  }

  _runThresholdCheck(cart) {
    this._showFreeSample = true
    let cartTotal = (cart.total_price / 100).toFixed(2)
    let cartCount = cart.item_count

    if ( this.thresholdEnabled ) {
      if ( this.thresholdType == 'quantity' ){
        if ( cartCount < this.thresholdLimit ){
          this._showFreeSample = false
        }
      } else {
        if ( cartTotal < this.thresholdLimit ){
          this._showFreeSample = false
        }
      }
    }

    return this._showFreeSample
  }
}

window.customElements.define('main-cart', MainCart)
